import { render } from "./AddArticle.vue?vue&type=template&id=0cd1226e"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__